import styled from 'styled-components';

export const CartEntryQuantityText = styled.div`
  width: 2rem;
  text-align: center;
`;
